import { AppConfig } from '../core-bundle/config/app-config';
import { FF_SHOW_PRICING_PAGE_TO_FA_EXPERIMENT } from '@wetransfer/transfer/constant/experiments';
import { PLAN_TIER } from '@wetransfer/transfer/constant/plan-tier';
import Helper from '@wetransfer/transfer/helper';
import Cookie from '@wetransfer/transfer/modules/concorde-cookie';
import { getVariant } from '@wetransfer/transfer/modules/experiments';
import Router from '@wetransfer/transfer/modules/router';

const setUserUploadCounter = (domain) => {
  let cookieValue = Cookie.get(
    AppConfig.cookies.showPricingPageToFAExperiment.name
  );

  if (!cookieValue) {
    const now = new Date();
    //for the first time we need one month before today
    //to be able to show PricingPage for the first time
    const newDate = `${now.getMonth()}/${now.getDate()}/${now.getFullYear()}`;
    cookieValue = [newDate, 1, false].join(',');

    Cookie.set(
      AppConfig.cookies.showPricingPageToFAExperiment.name,
      cookieValue,
      { domain }
    );

    return;
  }

  cookieValue = cookieValue.split(',');
  const [date, uploadCounter] = cookieValue;
  const daysSince = Helper.getDaysBetweenDates(date, new Date());

  // Check if daysSince is a number
  if (isNaN(daysSince)) {
    return false;
  }

  //On the next session after having sent 3 transfers within 30 days.
  const showPricingPage = daysSince >= 30 && parseInt(uploadCounter) >= 2;
  cookieValue = [date, parseInt(uploadCounter) + 1, showPricingPage].join(',');

  Cookie.set(
    AppConfig.cookies.showPricingPageToFAExperiment.name,
    cookieValue,
    { domain }
  );
};

const showPricingPageToFA = (domain) => {
  let cookieValue = Cookie.get(
    AppConfig.cookies.showPricingPageToFAExperiment.name
  );

  if (!cookieValue) return;

  cookieValue = cookieValue.split(',');
  const [, , showPricingPage] = cookieValue;

  if (showPricingPage === 'true') {
    const now = new Date();

    const newDate = `${
      now.getMonth() + 1
    }/${now.getDate()}/${now.getFullYear()}`;
    cookieValue = [newDate, 0, false].join(',');

    Cookie.set(
      AppConfig.cookies.showPricingPageToFAExperiment.name,
      cookieValue,
      { domain }
    );

    Router.navigateTo('/pricing');
  }
};

const isPricingPageExperimentVisible = (currentUser) => {
  return (
    getVariant(FF_SHOW_PRICING_PAGE_TO_FA_EXPERIMENT) === 'on' &&
    currentUser.planTier === PLAN_TIER.FREE
  );
};

export default {
  setUserUploadCounter,
  showPricingPageToFA,
  isPricingPageExperimentVisible,
};
